// Props for the useU3148LoadLogicalUnitActionHandlers hook
export interface U3148LoadLogicalUnitActionHandlersParams<T = any> {
  doLoadLogicalUnitFn: () => Promise<any>;
  onSuccess?: (rows: T[]) => void;
  onError?: (errors: { error: any }) => void;
}

// Return type for the useU3148LoadLogicalUnitActionHandlers hook
export interface U3148LoadLogicalUnitActionHandlersReturn {
  loadLogicalUnitActions: () => void;
}

// Handlers for loading logical unit actions
export function useU3148LoadLogicalUnitActionHandlers<T extends { id: string } = any>({
  doLoadLogicalUnitFn,
  onSuccess,
  onError,
}: U3148LoadLogicalUnitActionHandlersParams<T>): U3148LoadLogicalUnitActionHandlersReturn {
  const loadLogicalUnitActions = async () => {
    try {
      const response = await doLoadLogicalUnitFn();
      const rows: T[] = response.data.results as unknown as T[];

      if (onSuccess) {
        onSuccess(rows);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { loadLogicalUnitActions };
}
